import { render, staticRenderFns } from "./PromoCollapse.vue?vue&type=template&id=75596feb&scoped=true&lang=pug"
import script from "./PromoCollapse.vue?vue&type=script&lang=js"
export * from "./PromoCollapse.vue?vue&type=script&lang=js"
import style0 from "./PromoCollapse.vue?vue&type=style&index=0&id=75596feb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75596feb",
  null
  
)

export default component.exports